var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box"},[(_vm.title)?_c('div',{staticClass:"cb-title"},[_c('span',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),(_vm.$slots['body'])?_c('div',{staticClass:"cb-body"},[_vm._t("body")],2):_vm._e(),(_vm.$slots['footer'])?_c('div',{staticClass:"cb-footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }